
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { useAdminStats } from '@/hooks/admin/useAdminStats';
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const NewSubscriptionsTable: React.FC = () => {
  const { newSubscriptionsByDay, isLoadingHistorical, errorHistorical } = useAdminStats();
  
  if (isLoadingHistorical) {
    return <div className="flex justify-center items-center h-20">Loading data...</div>;
  }
  
  if (errorHistorical) {
    return <div className="flex justify-center items-center h-20 text-red-500">{errorHistorical}</div>;
  }
  
  // Format the date for display in New Zealand timezone and reverse the order
  const formattedData = [...newSubscriptionsByDay]
    .map(stat => {
      const nzDate = toZonedTime(new Date(stat.date), 'Pacific/Auckland');
      return {
        ...stat,
        date: format(nzDate, 'MMM d')
      };
    })
    .reverse(); // Reverse the order so newest dates appear first

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead className="text-right">Pending</TableHead>
            <TableHead className="text-right">Monthly</TableHead>
            <TableHead className="text-right">Annual</TableHead>
            <TableHead className="text-right">Lifetime</TableHead>
            <TableHead className="text-right">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {formattedData.map((row) => (
            <TableRow key={row.date}>
              <TableCell>{row.date}</TableCell>
              <TableCell className="text-right">{row.pending}</TableCell>
              <TableCell className="text-right">{row.monthly}</TableCell>
              <TableCell className="text-right">{row.annual}</TableCell>
              <TableCell className="text-right">{row.lifetime}</TableCell>
              <TableCell className="text-right">{row.total}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default NewSubscriptionsTable;
